<template>
    <div class="px-sm-0 px-2">
        <v-btn block :loading="loading" :disabled="loading" color="secondary" depressed tile large @click="submit($event)">Dokončit objednávku</v-btn>
        <p class="caption mt-2">Dokončením objednávky potvrzujete, že jste se seznámil s  <a
                target="_blank"
                class="secondary--text"
                href="/pdf/Zoo_Liberec_VOP_navrh_v10_FINAL_2020_05_31.pdf"
                @click.stop
        >Obchodními podmínkami</a>.</p>
        <v-checkbox color="secondary" v-model="form.marketingAgreement">
            <template v-slot:label>
                <div>
                    Souhlasím se zasíláním marketingových sdělení týkajících se Čepro, a. s.
                </div>
            </template>
        </v-checkbox>
    </div>
</template>

<script>
    export default {
        name: 'PlaceOrder',
        props: ['form', 'loading'],
        data () {
            return {
                rules: window.validationRules.getRules()
            }
        },
        methods: {
            submit(event) {
                this.$emit('submit', event);
            }
        }
    }
</script>
